export function utcWeekday(date = new Date()) {
  return (date.getUTCDay() + 6) % 7; // 0=Mon, 6=Sun, aligned with backend Python weekday()
}

export const CHECKIN_FREQUENCY_LABELS = {
  DAILY: "Tous les jours",
  EVERY_2_DAYS: "1 jour sur 2",
  "3X_WEEK": "3x / semaine",
  "1X_WEEK": "1x / semaine",
};

export function getCheckinFrequencyLabel(frequency = "DAILY") {
  return CHECKIN_FREQUENCY_LABELS[frequency || "DAILY"] || CHECKIN_FREQUENCY_LABELS.DAILY;
}

export function coerceDate(value) {
  if (!value) return null;
  const date = value instanceof Date ? value : new Date(value);
  return Number.isNaN(date.getTime()) ? null : date;
}

export function startOfUtcDay(date = new Date()) {
  return new Date(Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate()));
}

export function isCheckinScheduledToday(frequency = "DAILY", date = new Date()) {
  const weekday = utcWeekday(date);
  if (frequency === "DAILY") return true;
  if (frequency === "EVERY_2_DAYS") return [0, 2, 4, 6].includes(weekday); // Mon, Wed, Fri, Sun
  if (frequency === "3X_WEEK") return [0, 2, 4].includes(weekday); // Mon, Wed, Fri
  if (frequency === "1X_WEEK") return weekday === 0; // Monday
  return true;
}

export function isSameUtcDay(a, b = new Date()) {
  const date = coerceDate(a);
  if (!date) return false;
  if (Number.isNaN(date.getTime())) return false;
  return date.getUTCFullYear() === b.getUTCFullYear()
    && date.getUTCMonth() === b.getUTCMonth()
    && date.getUTCDate() === b.getUTCDate();
}

export function isScheduledCheckinDue(patient, lastScheduledCheckin, date = new Date()) {
  const frequency = patient?.checkinFrequency || "DAILY";
  return isCheckinScheduledToday(frequency, date) && !isSameUtcDay(lastScheduledCheckin?.createdAt, date);
}

export function getMostRecentScheduledCheckinDate(frequency = "DAILY", date = new Date()) {
  const dayStart = startOfUtcDay(date);
  for (let offset = 0; offset <= 7; offset += 1) {
    const candidate = new Date(dayStart);
    candidate.setUTCDate(dayStart.getUTCDate() - offset);
    if (isCheckinScheduledToday(frequency || "DAILY", candidate)) {
      return candidate;
    }
  }
  return dayStart;
}

export function getScheduledCheckinExpectation(patient, lastScheduledCheckin, date = new Date()) {
  const frequency = patient?.checkinFrequency || "DAILY";
  const expectedDate = getMostRecentScheduledCheckinDate(frequency, date);
  const startDate = coerceDate(patient?.startDate || patient?.createdAt);
  const startDay = startDate ? startOfUtcDay(startDate) : null;
  const lastAt = coerceDate(lastScheduledCheckin?.createdAt || lastScheduledCheckin || patient?.lastCheckinAt);

  if (startDay && expectedDate < startDay) {
    return {
      isMissing: false,
      expectedDate,
      lastCheckinAt: lastAt,
      frequency,
      frequencyLabel: getCheckinFrequencyLabel(frequency),
      reason: "not_started",
    };
  }

  const isMissing = !lastAt || lastAt < expectedDate;
  return {
    isMissing,
    expectedDate,
    lastCheckinAt: lastAt,
    frequency,
    frequencyLabel: getCheckinFrequencyLabel(frequency),
    daysLate: Math.max(0, Math.floor((startOfUtcDay(date) - expectedDate) / 86400000)),
    reason: isMissing ? "expected_checkin_missing" : "up_to_date",
  };
}